<p-toast></p-toast>
<main class="main">
  <pinnakl-spinner></pinnakl-spinner>
  <router-outlet></router-outlet>
</main>
